var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35627 5.38369C2.12727 5.13707 2 4.81297 2 4.47642V3.33334C2 2.96515 2.29848 2.66667 2.66667 2.66667H13C13.3682 2.66667 13.6667 2.96515 13.6667 3.33334V4.48517C13.6667 4.81647 13.5433 5.13591 13.3207 5.38124L9.60437 9.47605C9.49304 9.59872 9.43137 9.75844 9.43137 9.92409V12.8413C9.43137 13.266 9.03961 13.5824 8.62445 13.493L6.85975 13.1133C6.55263 13.0472 6.33333 12.7757 6.33333 12.4615V9.92847C6.33333 9.76019 6.26969 9.59814 6.15519 9.47483L2.35627 5.38369Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFilter;